import { createSlice } from '@reduxjs/toolkit';

// Helper to get user from localStorage on refresh
const savedUser = JSON.parse(localStorage.getItem('userSession')) || null;

const initialState = {
  user: savedUser, 
  isLoggedIn: !!savedUser,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.user = action.payload;
      state.isLoggedIn = true;
      state.error = null;
      // Persistence
      // localStorage.setItem('userSession', JSON.stringify(action.payload));
    },
    logout: (state) => {
      state.user = null;
      state.isLoggedIn = false;
      state.error = null;
      localStorage.removeItem('userSession');
    },
    loginFailure: (state, action) => {
      state.user = null;
      state.isLoggedIn = false;
      state.error = action.payload;
    },
    // ADD THIS: To update user info without logging out
    updateUser: (state, action) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
        // localStorage.setItem('userSession', JSON.stringify(state.user));
      }
    },
  },
});

export const { loginSuccess, loginFailure, logout, updateUser } = authSlice.actions;
export default authSlice.reducer;